import {
  CameraIcon,
  CarIcon,
  ClockIcon,
  CoffeeIcon,
  CreditCardIcon,
  DropIcon,
  LeafIcon,
  LightningIcon,
  MapPinIcon,
  MedalIcon,
  ShieldCheckIcon,
  SparkleIcon,
  StarIcon,
  ThumbsUpIcon,
  WrenchIcon,
  type Icon as PhosphorIcon,
} from '@phosphor-icons/react';
import type { InfoCardIcon } from '@shared/info-card-icons';

/** Info-card icon names from business.json → Phosphor icons. */
export const INFO_ICONS: Record<InfoCardIcon, PhosphorIcon> = {
  sparkle: SparkleIcon,
  'shield-check': ShieldCheckIcon,
  clock: ClockIcon,
  car: CarIcon,
  drop: DropIcon,
  wrench: WrenchIcon,
  medal: MedalIcon,
  coffee: CoffeeIcon,
  camera: CameraIcon,
  'credit-card': CreditCardIcon,
  'map-pin': MapPinIcon,
  'thumbs-up': ThumbsUpIcon,
  leaf: LeafIcon,
  lightning: LightningIcon,
  star: StarIcon,
};

export function infoIcon(name: string): PhosphorIcon {
  return INFO_ICONS[name as InfoCardIcon] ?? SparkleIcon;
}
